
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M11.988 22.265a9.763 9.763 0 01-4.579-1.153 9.698 9.698 0 01-4.575-5.279A3.36 3.36 0 010 12.503c0-1.626 1.148-3 2.714-3.31.333-2.148 1.503-4.096 3.316-5.508C7.749 2.346 9.925 1.578 12 1.578c2.076 0 4.251.768 5.97 2.107 1.813 1.413 2.983 3.36 3.316 5.508A3.37 3.37 0 0124 12.503a3.4 3.4 0 01-2.834 3.332 9.768 9.768 0 01-9.178 6.43zM12 3.078c-3.52 0-7.527 2.623-7.863 6.859a.755.755 0 01-.748.691A1.884 1.884 0 001.5 12.503c0 1.034.841 1.875 1.875 1.875.336 0 .636.219.732.532a8.202 8.202 0 004.008 4.879 8.253 8.253 0 003.874.976c.812 0 1.623-.121 2.41-.361a8.235 8.235 0 005.494-5.494.746.746 0 01.718-.532 1.884 1.884 0 001.889-1.875 1.877 1.877 0 00-1.875-1.875.755.755 0 01-.761-.691c-.252-3.18-2.581-5.37-5.019-6.313.102.305.155.626.154.955 0 .801-.312 1.555-.879 2.121a2.983 2.983 0 01-2.121.878 3.004 3.004 0 01-2.828-2 .745.745 0 01.03-.573.744.744 0 01.677-.427c.317 0 .601.201.707.501.211.598.78.999 1.414 1 .401 0 .777-.156 1.061-.439.283-.283.44-.66.44-1.06a1.49 1.49 0 00-.439-1.061A1.488 1.488 0 0012 3.078z"}}),_c('path',{attrs:{"d":"M12 18.501a3.747 3.747 0 01-2.48-.935.749.749 0 11.993-1.125c.41.361.938.56 1.487.56s1.078-.199 1.488-.561a.749.749 0 11.993 1.124 3.744 3.744 0 01-2.481.937zM15.75 13.253a2.252 2.252 0 01-2.25-2.25.75.75 0 011.5 0 .75.75 0 001.5 0 .75.75 0 011.5 0 2.252 2.252 0 01-2.25 2.25zM8.25 13.253A2.252 2.252 0 016 11.003a.75.75 0 011.5 0 .75.75 0 001.5 0 .75.75 0 011.5 0 2.252 2.252 0 01-2.25 2.25z"}})])
          )
        }
      }
    